/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Moje objednávka`
};

const da_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Min ordre`
};

const de_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Meine Bestellung`
};

const en_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `My order`
};

const es_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Mi pedido`
};

const fr_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Ma commande`
};

const hu_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `A rendelésem`
};

const it_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Il mio ordine`
};

const nl_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn bestelling`
};

const pl_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Moje zamówienie`
};

const pt_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Meu pedido`
};

const sv_my_order = /** @type {(inputs: {}) => string} */ () => {
	return `Min beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const my_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.my_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("my_order", locale)
	if (locale === "cs") return cs_my_order(inputs)
	if (locale === "da") return da_my_order(inputs)
	if (locale === "de") return de_my_order(inputs)
	if (locale === "en") return en_my_order(inputs)
	if (locale === "es") return es_my_order(inputs)
	if (locale === "fr") return fr_my_order(inputs)
	if (locale === "hu") return hu_my_order(inputs)
	if (locale === "it") return it_my_order(inputs)
	if (locale === "nl") return nl_my_order(inputs)
	if (locale === "pl") return pl_my_order(inputs)
	if (locale === "pt") return pt_my_order(inputs)
	return sv_my_order(inputs)
};